(function () {
  const MODEL_KEY = 'cb_macbook_model';
  const OPTION_NAME = 'MACBOOK MODEL';

  // ============================================================
  // Step 1：儲存客人選擇嘅型號
  // ============================================================
  function saveSelectedModel() {
    const url = new URL(window.location.href);
    const variantId = url.searchParams.get('variant');
    if (!variantId) return;

    // 從 Shopify product JSON 攞 variant 資料
    const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    if (!handle) return;

    fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .then(product => {
        const variant = product.variants.find(v => String(v.id) === variantId);
        if (!variant) return;

        const modelOption = product.options.find(o => o.name === OPTION_NAME);
        if (!modelOption) return;

        const optionIndex = product.options.indexOf(modelOption);
        const modelValue = variant[`option${optionIndex + 1}`];
        if (!modelValue) return;

        localStorage.setItem(MODEL_KEY, modelValue);
        console.log('[ColourBanana] Saved model:', modelValue);
      })
      .catch(() => {});
  }

  // ============================================================
  // Step 2：預選儲存嘅型號
  // ============================================================
  function preselectModel() {
    const savedModel = localStorage.getItem(MODEL_KEY);
    if (!savedModel) return;

    // 確認係 MacBook case 產品頁
    fetch(`${window.location.pathname}.js`)
      .then(r => r.json())
      .then(product => {
        const modelOption = product.options.find(o => o.name === OPTION_NAME);
        if (!modelOption) return;

        const optionIndex = product.options.indexOf(modelOption);

        // 搵對應 variant
        const targetVariant = product.variants.find(v =>
          v[`option${optionIndex + 1}`] === savedModel
        );
        if (!targetVariant) return;

        // 確認唔係已經選緊呢個 variant
        const url = new URL(window.location.href);
        const currentVariantId = url.searchParams.get('variant');
        if (String(targetVariant.id) === currentVariantId) return;

        // 更新 URL 同預選
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('variant', targetVariant.id);
        window.history.replaceState({}, '', newUrl.toString());

        // 更新下拉選單
        const selects = document.querySelectorAll('select');
        selects.forEach(select => {
          Array.from(select.options).forEach(option => {
            if (option.text.trim() === savedModel || option.value === savedModel) {
              select.value = option.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });

        console.log('[ColourBanana] Preselected model:', savedModel);
      })
      .catch(() => {});
  }

  // ============================================================
  // Step 3：監聽 variant 切換（客人手動改）
  // ============================================================
  function watchVariantChange() {
    // 監聽 URL 變化
    let lastVariant = new URL(window.location.href).searchParams.get('variant');

    const observer = new MutationObserver(() => {
      const currentVariant = new URL(window.location.href).searchParams.get('variant');
      if (currentVariant && currentVariant !== lastVariant) {
        lastVariant = currentVariant;
        saveSelectedModel();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // 監聽 select change
    document.addEventListener('change', (e) => {
      if (e.target.tagName === 'SELECT') {
        setTimeout(saveSelectedModel, 300);
      }
    });

    // 監聽 popstate（瀏覽器前後）
    window.addEventListener('popstate', saveSelectedModel);
  }

  // ============================================================
  // 主程式
  // ============================================================
  function init() {
    const isProductPage = window.location.pathname.includes('/products/');
    if (!isProductPage) return;

    // 先儲存當前選擇
    saveSelectedModel();

    // 預選儲存嘅型號
    preselectModel();

    // 開始監聽變化
    watchVariantChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();